(function () {
  function getSectionId() {
    const productGrid = document.getElementById('product-grid');
    return productGrid && productGrid.getAttribute('data-id');
  }

  function buildFetchUrl(nextUrl, sectionId) {
    const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    return nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);
  }

  function setLoading(link, loading) {
    if (!link) return;
    if (loading) {
      link.setAttribute('aria-busy', 'true');
      link.classList.add('loading');
      const label = link.textContent.trim();
      link.setAttribute('data-original-label', label);
      link.textContent = 'Loading…';
      link.style.color = "white";
    } else {
      link.removeAttribute('aria-busy');
      link.classList.remove('loading');
      const original = link.getAttribute('data-original-label');
      if (original) link.textContent = original;
    }
  }

  function appendProducts(parsedDoc, sectionId, currentUl) {
    const responseUl = parsedDoc.getElementById('Slider-' + sectionId);
    if (!responseUl || !currentUl) return;
    const items = responseUl.querySelectorAll(':scope > li');
    items.forEach(function (li) {
      currentUl.appendChild(li.cloneNode(true));
    });
  }

  function replaceLoadMoreContainer(parsedDoc, currentContainer) {
    const parsedContainer = parsedDoc.querySelector('[data-load-more-container]');
    if (!parsedContainer || !currentContainer) return;
    currentContainer.innerHTML = parsedContainer.innerHTML;
  }

  function replaceGridWithFirstPage(parsedDoc, sectionId) {
    const responseUl = parsedDoc.getElementById('Slider-' + sectionId);
    const currentUl = document.getElementById('Slider-' + sectionId);
    const currentContainer = document.querySelector('[data-load-more-container]');
    if (!responseUl || !currentUl) return;
    currentUl.innerHTML = responseUl.innerHTML;
    replaceLoadMoreContainer(parsedDoc, currentContainer);
    updateProductCount(parsedDoc);
    if (typeof initializeScrollAnimationTrigger === 'function' && currentUl) {
      const newItems = currentUl.querySelectorAll('.scroll-trigger');
      if (newItems.length) {
        newItems.forEach(function (el) {
          el.classList.add('scroll-trigger--cancel');
        });
        initializeScrollAnimationTrigger(currentUl.innerHTML);
      }
    }
  }

  function updateProductCount(parsedDoc) {
    const parsedCount = parsedDoc.getElementById('ProductCountDesktop');
    const currentCount = document.getElementById('ProductCountDesktop');
    if (parsedCount && currentCount) {
      currentCount.innerHTML = parsedCount.innerHTML;
    }
  }

  function performLoadMore(sectionId, link) {
    const l = link || document.querySelector('[data-load-more][data-section-id="' + sectionId + '"]');
    if (!l || l.getAttribute('aria-busy') === 'true') return Promise.resolve();
    const sid = l.getAttribute('data-section-id') || getSectionId();
    const nextUrl = l.getAttribute('href');
    if (!sid || !nextUrl) return Promise.resolve();

    const fetchUrl = buildFetchUrl(nextUrl, sid);
    setLoading(l, true);

    return fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const currentUl = document.getElementById('Slider-' + sid);
        const currentContainer = document.querySelector('[data-load-more-container]');

        appendProducts(parsed, sid, currentUl);
        replaceLoadMoreContainer(parsed, currentContainer);
        updateProductCount(parsed);

        if (typeof initializeScrollAnimationTrigger === 'function' && currentUl) {
          const newItems = currentUl.querySelectorAll('.scroll-trigger');
          if (newItems.length) {
            newItems.forEach(function (el) {
              el.classList.add('scroll-trigger--cancel');
            });
            initializeScrollAnimationTrigger(currentUl.innerHTML);
          }
        }
      })
      .catch(function () {
        // On error, just stop loading; do not redirect to avoid full page reload
      })
      .finally(function () {
        setLoading(l, false);
      });
  }

  function onLoadMoreClick(e) {
    const link = e.target && e.target.closest ? e.target.closest('[data-load-more]') : null;
    if (!link || link.getAttribute('aria-busy') === 'true') return;

    e.preventDefault();
    e.stopPropagation();

    const sectionId = link.getAttribute('data-section-id') || getSectionId();
    performLoadMore(sectionId, link);
  }

  window.loadMoreProducts = function (sectionId) {
    const sid = sectionId || getSectionId();
    if (!sid) return Promise.resolve();
    return performLoadMore(sid, null);
  };

  window.resetCollectionGridToFirstPage = function (sectionId, firstPageUrl) {
    const sid = sectionId || getSectionId();
    if (!sid || !firstPageUrl) return Promise.resolve();
    const fetchUrl = buildFetchUrl(firstPageUrl, sid);
    return fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        replaceGridWithFirstPage(parsed, sid);
      })
      .catch(function () {});
  };

  function init() {
    document.addEventListener('click', function (e) {
      const link = e.target && e.target.closest ? e.target.closest('[data-load-more]') : null;
      if (!link) return;
      if (link.getAttribute('aria-busy') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      onLoadMoreClick(e);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
